import {QUERY_KEYS} from '@/queryClient'
import {useQuery} from '@tanstack/react-query'
import {httpGetVideoFilters} from '../services/workspaces.http'

export const useGetVideoFilters = () =>
    useQuery({
        queryKey: [QUERY_KEYS.VIDEO_FILTERS],
        queryFn: () => httpGetVideoFilters()
    })
